export const colors = {
  gray2: '#B2B5BC',
  gray3: '#CECED7',
  gray4: '#DEDEE4',
  mainDark: '#0C0838',
  lineDark: '#3D3960',
  link: '#DC459F',
  white: '#fff'
}